<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">Bank Transactions</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">A/C Holder Name</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">Financial Year</v-toolbar-title>
        </v-toolbar>
        <!-- <div class="v-select__slot">
          <label for="input-1335457" class="v-label v-label--active theme--dark" 
          style="left:0px;right:auto;position:absolute;">Available Component(s)
          </label>
          
          <div class="v-select__selections">
            <div class="v-select__selection v-select__selection--comma">v-form</div>
            <input id="input-1335457" 
             readonly="readonly" 
              type="text" 
              aria-readonly="true">
          </div>
          <div class="v-input__append-inner">
            <div class="v-input__icon v-input__icon--append">
              <i aria-hidden="true" 
                class="v-icon notranslate mdi mdi-menu-down theme--dark">
              </i>
            </div>
          </div>
        </div> -->

        <v-toolbar class="primary white--text">
          <v-toolbar-sub-title class="text-xs-center">Bank Name</v-toolbar-sub-title>
          <v-spacer></v-spacer>
          <v-toolbar-sub-title class="text-xs-center">Account Holder Name</v-toolbar-sub-title>
          <v-spacer></v-spacer>
          <v-toolbar-sub-title class="text-xs-center">Account Number</v-toolbar-sub-title>
          <v-spacer></v-spacer>
          <v-toolbar-sub-title class="text-xs-center">Account Type</v-toolbar-sub-title>
          <v-spacer></v-spacer>
          <v-toolbar-sub-title class="text-xs-center">Firm Name</v-toolbar-sub-title>
        </v-toolbar>
      </v-card>
    

    <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
    >
       <template slot="items" slot-scope="props">
          <td class="text-xs-left nowrap"><b>{{ props.item.date }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.transactionID}}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.transactionType}}</b></td> 
          <td class="text-xs-left nowrap"><b>&#8377;{{ props.item.debited }}</b></td>
          <td class="text-xs-left nowrap"><b>&#8377;{{ props.item.credited }}</b></td>
          <td class="text-xs-left nowrap"><b>&#8377;{{ props.item.balance }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.description}}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.remark }}</b></td>          
        </template>
    </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']

export default {
  data () {
    return {
        headers: [
        { text: 'Date', sortable: false, value: 'date' },
        { text: 'TransactionID', sortable: false, value: 'transactionID' },
        { text: 'TransactionType', sortable: false, value: 'transactionType' },
        { text: 'Debit', sortable: false, value: 'debited' },
        { text: 'Credit', sortable: false, value: 'credited' },
        { text: 'Balance', sortable: false, value: 'balance' },
        { text: 'Description', sortable: false, value: 'description' },
        { text: 'Remark', sortable: false, value: 'remark' },
      ],
      desserts: [
        {
          date: '15-04-2019',
          transactionType: '',
          transactionID:'',
          debited: '',
          credited: 400000,
          balance: 400000,
          description: 'opening balance',
          remark:'2019 opening'
        },
        {
          date: '23-05-2019',
          transactionType: 'NEFT',
          transactionID:'#$1$5&87#7',
          debited: 276000,
          credited: '',
          balance: 124000,
          description: 'neft to vicky',
          remark:'chq-02'
        },
        {
          date: '08-06-2019',
          transactionType: 'IMPS',
          transactionID:'#$56$&87#7',
          debited: '',
          credited: 246000,
          balance: 370000,
          description: 'Anshul Malpani',
          remark:'7896541235'
        },
        {
          date: '28-07-2019',
          transactionType: 'NEFT',
          transactionID:'#$235&87#7',
          debited: 170000,
          credited: '',
          balance: 200000,
          description: 'cash',
          remark:'Deepak'
        },
        {
          date: '28-08-2019',
          transactionType: 'CASH',
          transactionID:'',
          debited: '',
          credited: 150000,
          balance: 350000,
          description: 'cash deposit by sonu',
          remark:'Cash'
        },
      ],
      firms: {},
      buyerById: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Informations/Bankstatement/index.vue